export const SORT_METHODS = {
    NUMBER_OF_LOGS: 'numberOfLogs',
    ALPHABETICAL: 'alphabetical',
};
